'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
var sharedComponents = require('../shared-components.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('../icon.js');
var style = require('../style-cf128dc7.js');
require('../style-222d2b0f.js');
var b14 = require('../typography/b14.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  resize: vertical;\n  height: ", ";\n  padding: 10px;\n"], ["\n  ", ";\n  resize: vertical;\n  height: ", ";\n  padding: 10px;\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  margin-top: 3px;\n  color: ", ";\n"], ["\n  margin-top: 3px;\n  color: ", ";\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  grid-column: 1;\n"], ["\n  grid-column: 1;\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  grid-column: 2;\n  gap: 5px;\n"], ["\n  display: flex;\n  grid-column: 2;\n  gap: 5px;\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: 3px;\n"], ["\n  color: ", ";\n  margin-top: 3px;\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-content: space-between;\n"], ["\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-content: space-between;\n"]);

var StyledTextArea = styled__default.textarea(_templateObject, style.commonInputStyle, function (props) {
  return props.height ? "" + props.height : "100px";
});

var StyledB14 = styled__default(b14.default)(_templateObject2, function (_ref) {
  var hasError = _ref.hasError,
      color = _ref.color;
  return hasError ? settings.COLOR.softRed : color;
});

var StyledErrorMessageContainer = styled__default.div(_templateObject3);
var StyledCharacterLimitContainer = styled__default.div(_templateObject4);
var StyledIcon = styled__default(icon.Icon)(_templateObject5, settings.COLOR.softRed);
var StyledTextAreaFooter = styled__default.div(_templateObject6);

/**
 * The InputTextField component
 * @param {String} label the text to show above the text field
 * @param {Boolean} isRequired the isRequired status to show * sign
 * @param {Boolean} disabled the disabled status to disable the input text field
 * @param {String} error the text to show below the text field when has error
 * @param {String} width the width of input text field
 * @param {String} height the height of input text field
 * @param {String} textColor the color of label
 * @param {Object} labelStyle the style for label component
 * @param {Object} textAreaStyle the style for input text field component
 * @param {Object} ErrorMessageStyle the style for error message
 */
/* eslint-disable react/prefer-stateless-function */

var InputTextArea = function (_Component) {
  _babelHelpers.inherits(InputTextArea, _Component);

  function InputTextArea() {
    _babelHelpers.classCallCheck(this, InputTextArea);
    return _babelHelpers.possibleConstructorReturn(this, (InputTextArea.__proto__ || Object.getPrototypeOf(InputTextArea)).apply(this, arguments));
  }

  _babelHelpers.createClass(InputTextArea, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          label = _props.label,
          isRequired = _props.isRequired,
          disabled = _props.disabled,
          error = _props.error,
          textColor = _props.textColor,
          labelStyle = _props.labelStyle,
          textAreaStyle = _props.textAreaStyle,
          ErrorMessageStyle = _props.ErrorMessageStyle,
          inputRef = _props.inputRef,
          mb = _props.mb,
          value = _props.value,
          characterLimit = _props.characterLimit,
          _props$showLabelWhenD = _props.showLabelWhenDisabled,
          showLabelWhenDisabled = _props$showLabelWhenD === undefined ? false : _props$showLabelWhenD;

      return React__default.createElement(
        sharedComponents.InputGroup,
        { mb: mb },
        React__default.createElement(
          sharedComponents.StyledLabel,
          {
            textColor: textColor,
            labelStyle: labelStyle,
            disabled: disabled && !showLabelWhenDisabled },
          label,
          isRequired && React__default.createElement(
            sharedComponents.RedText,
            { disabled: disabled && !showLabelWhenDisabled },
            " *"
          )
        ),
        React__default.createElement(StyledTextArea, _babelHelpers._extends({}, this.props, {
          hasError: error,
          style: textAreaStyle,
          ref: inputRef
        })),
        React__default.createElement(
          StyledTextAreaFooter,
          null,
          error && React__default.createElement(
            StyledErrorMessageContainer,
            null,
            React__default.createElement(
              sharedComponents.ErrorMessage,
              { ErrorMessageStyle: ErrorMessageStyle },
              error
            )
          ),
          characterLimit && React__default.createElement(
            StyledCharacterLimitContainer,
            null,
            error && React__default.createElement(StyledIcon, { name: "warning", size: "md" }),
            React__default.createElement(
              StyledB14,
              { hasError: error },
              value ? value.length.toLocaleString("en-US") : "0",
              "/",
              characterLimit.toLocaleString("en-US")
            )
          )
        )
      );
    }
  }]);
  return InputTextArea;
}(React.Component);

InputTextArea.propTypes = {
  /** component id */
  id: PropTypes.string.isRequired,
  /** text to display */
  label: PropTypes.string,
  /** indicator to display red sign */
  isRequired: PropTypes.bool,
  /** indicator to display disable text area */
  disabled: PropTypes.bool,
  /** error message to display under text area */
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** text area width */
  width: PropTypes.string,
  /** value for the textarea */
  value: PropTypes.string,
  /** the character limit for this input */
  characterLimit: PropTypes.number,
  /** text area height */
  height: PropTypes.string,
  /** text color of label */
  textColor: PropTypes.string,
  /** style to override label component */
  labelStyle: PropTypes.object,
  /** style to override input component */
  inputStyle: PropTypes.object,
  /** style to override error message component */
  ErrorMessageStyle: PropTypes.object
};
InputTextArea.__docgenInfo = {
  "description": "The InputTextField component\n@param {String} label the text to show above the text field\n@param {Boolean} isRequired the isRequired status to show * sign\n@param {Boolean} disabled the disabled status to disable the input text field\n@param {String} error the text to show below the text field when has error\n@param {String} width the width of input text field\n@param {String} height the height of input text field\n@param {String} textColor the color of label\n@param {Object} labelStyle the style for label component\n@param {Object} textAreaStyle the style for input text field component\n@param {Object} ErrorMessageStyle the style for error message",
  "methods": [],
  "displayName": "InputTextArea",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "component id"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display"
    },
    "isRequired": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display red sign"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display disable text area"
    },
    "error": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "error message to display under text area"
    },
    "width": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text area width"
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "value for the textarea"
    },
    "characterLimit": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "the character limit for this input"
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text area height"
    },
    "textColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text color of label"
    },
    "labelStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override label component"
    },
    "inputStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override input component"
    },
    "ErrorMessageStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override error message component"
    }
  }
};

exports.StyledB14 = StyledB14;
exports.StyledCharacterLimitContainer = StyledCharacterLimitContainer;
exports.StyledErrorMessageContainer = StyledErrorMessageContainer;
exports.StyledIcon = StyledIcon;
exports.StyledTextArea = StyledTextArea;
exports.StyledTextAreaFooter = StyledTextAreaFooter;
exports.default = InputTextArea;
//# sourceMappingURL=textarea.js.map
